import {
    DashboardOutlined,
    UserOutlined,
    ShoppingCartOutlined,
    FileTextOutlined,
    DropboxOutlined,
    AlertOutlined,
    DesktopOutlined,
    GroupOutlined,
    DollarCircleOutlined,
    KeyOutlined,
    UsergroupAddOutlined,
    CloudOutlined,
    ProfileOutlined,
} from '@ant-design/icons';
import CustomIcon from '../../components/CustomView/CustomIcon';
import empy_img from '../../../assets/employe.png';
import invoice_project from '../../../assets/Invoice-wise-projects.png';
import hrm_icon from '../../../assets/hrm-icon.png';

export const MenuList = [
    { key: 'dashboard', icon: <DashboardOutlined />, label: 'Dashboard', to: '/dashboard' },

    {
        key: 'workspace_management',
        icon: <CustomIcon image={invoice_project} />,
        label: 'Manage Workspace',
        children: [
            { key: 'sales_dashboard', label: 'Sales Dashboard', to: '/sales-dashboard' },
            { key: 'enquiry', label: 'Manage Enquiry', to: '/enquiry' },
            { key: 'Quotation', label: 'Manage Quotation', to: '/quotation' },
            { key: 'Invoice', label: 'Manage Invoice', to: '/invoice' },


            { key: 'view_invoice_project', label: 'Invoice-wise Projects', to: '/invoice-wise-projects' },
            // { key: 'manage-expense', label: 'Manage Expense', to: '/manage-expense' },
            // { key: 'manage-vendor', label: 'Manage Vendor', to: '/manage-vendor' },
        ]
    },

    {
        key: 'task_management',
        icon: <ProfileOutlined />,
        label: 'Project Management',

        children: [
            // { key: 'managetask', label: 'Overview Project and Task', to: '/manage-task' },
            { key: 'Projects', label: 'Manage Projects', to: '/projects' },

            { key: 'overview-project', label: 'Overview Project and Task', to: '/overview-project' },
            { key: 'meetings', label: 'Meetings', to: '/overview-project/meetings' },

            // { key: 'assignedtask', label: 'Assigned Task', to: '/assigned-task' },
            // { key: 'mytask', label: 'My Task', to: '/my-task' },
            { key: 'projecttimeline', label: 'Project TimeLine', to: '/project-timeline' },

        ]
    },

    {
        key: 'inventory_management',
        icon: <DropboxOutlined />,
        label: 'Inventory Management',
        children: [
            { key: 'inventory-dashboard', label: 'Inventory Dashboard', to: '/inventory' },
            { key: 'products-items', label: 'Products / Items', to: '/inventory/products-items' },
            { key: 'categories', label: 'Categories', to: '/inventory/categories' },
            { key: 'suppliers', label: 'Suppliers', to: '/inventory/suppliers' },
            { key: 'inventory-purchase-orders', label: 'Purchase Orders', to: '/inventory/purchase-orders' },
            { key: 'goods-receipts', label: 'Goods Receipts', to: '/inventory/goods-receipts' },
            { key: 'stock-transfer', label: 'Stock Transfer', to: '/inventory/stock-transfer' },
             { key: 'adjustments', label: 'Adjustments', to: '/inventory/adjustments' },
{ key: 'stock-count', label: 'Stock Count', to: '/inventory/stock-count' },
            { key: 'low-stock-alert', label: 'Low Stock Alert', to: '/inventory/low-stock-alert' },
        ]
    },
    {
        key: 'finance',
        icon: <CustomIcon image={invoice_project} />,
        label: 'Finance',
        children: [
            { key: 'add vendor', label: 'Manage Vendor', to: '/manage-vendor' },
            { key: 'po', label: 'Purchase Order', to: '/purchase-order' },
            { key: 'Project Expenses', label: 'Project Expenses', to: '/project-expenses' },
            { key: 'utilitybil', label: 'Utility Bills', to: '/utility-bills' },
            // { key: 'payments', label: 'Payments', to: '/payments'},
            // { key: 'Projects', label: 'Manage Projects', to: '/projects' },
            {
                key: 'reprots', label: 'Reports', to: '/finance/reports',
                children: [
                    // { key: 'announcements', label: 'Announcements', to: '/announcements' },
                    { key: 'P & L Report', label: 'P & L Report', to: '/finance/reports/p-l' },
                    { key: 'Pay Mode Vise Reprt', label: 'Pay Mode Vise Reprt', to: '/finance/reports/pay-mode-vise' },
                ]
            },
        ]
    },

    {
        key: 'hrms',
        icon: <CustomIcon style={{ transform: "scale(1.2)", transformOrigin: "center center" }} image={hrm_icon} />,
        label: 'HRM Workspace',
        children: [
            // { key: 'announcements', label: 'Announcements', to: '/announcements' },
            { key: 'workforcemanagement', label: 'Workforce Management', to: '/workforce-management' },

            { key: 'addsalesexecutive', label: 'Add Employees', to: '/add-employees' },
            { key: 'assignsalesexecutive', label: 'Assign Sales Executive', to: '/assign-sales-executive' },
            { key: 'addsalestarget', label: 'Sales Target', to: '/sales-target' },

        ]
    },


    //  {
    //     key: 'leave_raise',
    //     icon: <FileTextOutlined />, 
    //     label: 'Leave Raise',
    //     children: [
    //         { key: 'leave_request', label: 'Leave Request', to: '/leave-request' },
    //     ],
    // },


    {
        key: 'admin_management',
        icon: <UsergroupAddOutlined />,
        label: 'Admin Management',
        children: [
            {
                key: 'user_management',
                label: 'User Management',
                children: [
                    { key: 'Manage_Organization', label: 'Manage Organization', to: '/manage-organization' },
                    { key: 'Manage_user', label: 'Manage Users', to: '/manage-user' },
                    { key: 'Manage_Permission', label: 'Manage Permission', to: '/manage-permission' },
                ]
            },
            { key: 'manage_empy_img', label: 'Manage Employees', to: '/manage-employees' },
            {
                key: 'compy_assets',

                label: 'Assets',
                children: [
                    { key: 'Bank details', label: 'Manage Bank Details', to: '/manage-bank-data' },
                    { key: 'Letter_Formats', label: 'Letter Formats', to: '/manage-letter-formats' },
                ]
            },
            { key: 'manage_services', label: 'Manage Services', to: '/manage-services' },
            { key: 'configuration', label: 'Configuration', to: '/configuration' },

        ]
    },
    {
        key: 'my_activity',
        icon: <ProfileOutlined />,
        label: 'My Activity',
        children: [
            { key: 'mytask', label: 'My Task', to: '/my-task' },
            {
                key: 'leave_raise',

                label: 'Leave Raise',
                children: [
                    { key: 'leave_request', label: 'Leave Request', to: '/leave-request' },
                ],
            },

            { key: 'complaint_request', label: 'Complaint Raise', to: '/complaint-raise' },

        ]
    },

];

